/* import __COLOCATED_TEMPLATE__ from './billing-period-toggle.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { BILLING_PERIODS } from 'embercom/lib/billing';
import { inject as service } from '@ember/service';
import type QuoteService from 'embercom/services/quote-service';

interface Args {
  loading: boolean;
  billingPeriod: BILLING_PERIODS;
  updateBillingPeriod: (value: BILLING_PERIODS) => void;
  isComparisonModal?: boolean;
  yearlySavingsAmount: number;
}

interface Signature {
  Element: HTMLElement;
  Args: Args;
}

export default class BillingPeriodToggle extends Component<Signature> {
  @tracked billingPeriod = this.args.billingPeriod;
  @service declare quoteService: QuoteService;

  get monthlyBillingPeriodValue() {
    return BILLING_PERIODS.Monthly;
  }

  get annualBillingPeriodValue() {
    return BILLING_PERIODS.Annual;
  }

  get yearlySavings() {
    return this.quoteService.formatPrice(this.args.yearlySavingsAmount);
  }

  @action
  toggleBillingPeriod(period: number) {
    let newPeriod = period === 1 ? this.monthlyBillingPeriodValue : this.annualBillingPeriodValue;

    this.billingPeriod = newPeriod;
    this.args.updateBillingPeriod(newPeriod);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AnnualPlans::BillingPeriodToggle': typeof BillingPeriodToggle;
  }
}
